import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  const isEn = language === "en";

  return (
    <button
      onClick={toggleLanguage}
      aria-label={`Switch to ${isEn ? "日本語" : "English"}`}
      className="relative flex items-center bg-slate-100 hover:bg-slate-200 rounded-full p-0.5 gap-0.5 transition-colors"
    >
      {/* Sliding highlight */}
      <span
        className={`absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-full bg-white shadow transition-all duration-200 ease-in-out ${
          isEn ? "left-0.5" : "left-[calc(50%+1px)]"
        }`}
      />

      {/* English */}
      <span
        className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full text-sm font-black text-slate-700 transition-opacity duration-150 ${
          isEn ? "opacity-100" : "opacity-40"
        }`}
      >
        EN
      </span>

      {/* Japanese */}
      <span
        className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full text-sm font-black text-slate-700 transition-opacity duration-150 ${
          !isEn ? "opacity-100" : "opacity-40"
        }`}
      >
        JP
      </span>
    </button>
  );
};

export default LanguageToggle;
